module.exports = __webpack_public_path__ + "media/static/logo-6aaaa36054d906602ba5c584fb744350.png";